export default __webpack_public_path__ + "static/media/arrow-return-right.d2029222.svg";